// import only notification so not all atoms get bundled
import notification from '@atoms/Notification';

import useResourceList from './useResourceList';
import useQuery from './useQuery';
import useMutation from './useMutation';

import api from '..';

export const useEventsList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'events', api: api.events }, queryVariables, queryConfig);

  return {
    events: queryResult.resolvedData,
    latestEvents: queryResult.latestData,
    ...queryResult,
  };
};

export const useEventsByIds = (ids, queryConfig = {}) => {
  const queryResult = useQuery(['events', { ids }], api.events.getByIds, {
    ...queryConfig,
    enabled: ids?.length > 0,
  });

  return {
    events: queryResult.data || [],
    ...queryResult,
  };
};

export const useEvent = (id, queryConfig = {}) => {
  const queryResult = useQuery(['event', { id }], api.events.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    event: queryResult.data || {},
    ...queryResult,
  };
};

export const useGetEventAppearance = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['event-appearance', { id }], api.events.getAppearance, {
    onError: (error) => {
      if (error?.response?.status !== 404) {
        notification.error({ message: error.message });
      }
    },
    ...queryConfig,
  });

  return {
    appearance: queryResult.data || {},
    ...queryResult,
  };
};

const createAppearanceMutation = (apiCall) => (queryConfig = {}) =>
  useMutation(apiCall, {
    onSuccess: () => notification.success({ message: 'Successfully saved appearance ' }),
    onError: () => notification.error({ message: 'Failed to save appearance' }),
    ...queryConfig,
  });

export const useCreateEventAppearance = createAppearanceMutation(api.events.createAppearance);
export const useUpdateEventAppearance = createAppearanceMutation(api.events.updateAppearance);
export const useUpsertEventAppearance = createAppearanceMutation(api.events.upsertAppearance);
